module.exports = __webpack_public_path__ + "img/representantes.684187de.webp";